<template>
  <div class="dojo-course">
    <div class="content">
      <div class="flex-content">
        <div class="course-list no-scrollbar">
          <ul>
            <li
              v-for="course in course_reversed"
              :key="course.id"
              @click="showContent(course)"
            >
              {{ course.title }}
              <hr />
            </li>
          </ul>
        </div>
        <div class="course-page no-scrollbar">
          <h3 style="text-align: center">{{ displayContent.title }}</h3>
          <hr style="color: grey; width: 50%;" />
          <p style="text-align: center">Author: {{ displayContent.author }}</p>
          <div v-html="displayContent.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";
export default {
  name: "DojoCourse",
  data() {
    return {
      dojo_course: [],
      displayContent: {
        title: "Vive la resistance",
        author: "Philippe Poutoux",
        text:
          "<p>Here you'll be able to learn or offer some knowledge on how to fight the MOFOs (Monopoly Owner Federated Oligarchs), by making music or any other means necessary... </p>" +
          "<p>Feel free to scroll and click on whichever tips interests you the most, else you can talk nonsense or music with other fellow crew members in the chat. </p>" +
          "Peace, love and loud kicks. <br/> - signé Philippe.",
      },
    };
  },
  firebase: {
    dojo_course: db.ref("dojo_course"),
  },
  computed: {
    course_reversed() {
      let arr = false;
      if (this.dojo_course.length > 0) {
        arr = this.dojo_course;
        arr = arr.reverse();
      }
      return arr;
    },
  },
  methods: {
    showContent(content) {
      this.displayContent.title = content.title;
      this.displayContent.author = content.author;
      this.displayContent.text = content.text;
    },
  },
};
</script>

<style lang="scss" scoped>
.dojo-course {
  position: absolute;
  top: 1vh;
  left: 1vw;
  width: 55vw;
  min-height: 97vh;
  background-image: url("../../assets/medias/images/scroll_course.png");
  background-size: 100% 100%;
  color: rgb(49, 42, 42);
}
.content {
  padding: 10vh;
  padding-top: 18vh;
  height: 60vh;
}

.flex-content {
  display: flex;
  height: 100%;
}

h2 {
  text-align: center;
}

.course-list {
  flex: 1;
  background-color: rgba(250, 250, 250, 0.5);
  border-radius: 15px;
  font-size: 1.5rem;
  overflow-y: scroll;
  max-height: 100%;
}

.course-page {
  flex: 2;
  padding: 10px;
  font-size: 1.2rem;
  overflow-y: scroll;

  h3 {
    margin-top: 0;
  }
}

ul {
  padding: 10px;
  margin: 0;
}

li {
  list-style: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 3px;
  }
}

@media screen and (max-width: 750px) {
  .course-list {
    font-size: 2.5vw;
  }

  .course-page {
    font-size: 2.2vw;
  }

  .content {
    padding-top: 18vh;
  }

  h2 {
    margin-bottom: 2vh;
    font-size: 5vh;
  }
}
</style>
